import type { LayoutPageConfig } from './types';

export const reportDetailPageConfig = {
  namespacesRequired: ['reporting', 'tables'],
  layout: {
    showHeaderPeriodFilter: false,
  },
} satisfies LayoutPageConfig;
